import { render, staticRenderFns } from "./PlotWidth.vue?vue&type=template&id=7c32f408&"
import script from "./PlotWidth.vue?vue&type=script&lang=ts&"
export * from "./PlotWidth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports